"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewFoodPage = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const FormLabel_1 = __importDefault(require("@mui/material/FormLabel"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const AttachFile_1 = __importDefault(require("@mui/icons-material/AttachFile"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const mui_file_input_1 = require("mui-file-input");
const utilities_1 = require("../../utilities");
const react_router_1 = require("react-router");
const demo_1 = require("@mui/x-date-pickers/internals/demo");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
const DateTimePicker_1 = require("@mui/x-date-pickers/DateTimePicker");
function Label({ componentName }) {
    const content = (react_1.default.createElement("span", null,
        react_1.default.createElement("strong", null, componentName),
        " for future food event"));
    return content;
}
const NewFoodPage = () => {
    // TODO close button
    // TODO SAVE IMAGES TO DATABASE(?)
    const navigate = (0, react_router_1.useNavigate)();
    const [selectedFiles, setSelectedFiles] = react_1.default.useState([]);
    // blob URLs are temporary URLs for <img> to get a preview of images before user uploads
    const [blobUrls, setBlobUrls] = react_1.default.useState([]);
    // For showing a preview of the pictures
    (0, react_1.useEffect)(() => {
        const revokeCurrentURLs = () => {
            for (const blob of blobUrls) {
                URL.revokeObjectURL(blob);
            }
        };
        // revoke selected files first
        revokeCurrentURLs();
        // get the blob URLs now
        setBlobUrls(selectedFiles.map((file) => URL.createObjectURL(file)));
        // revoke blob URLs when destroying the component
        return revokeCurrentURLs;
    }, [selectedFiles]);
    // type from https://www.robinwieruch.de/typescript-react-useref/
    const foodCategoryRef = (0, react_1.useRef)(null);
    const foodTypeRef = (0, react_1.useRef)(null);
    const locationRef = (0, react_1.useRef)(null);
    const descriptionRef = (0, react_1.useRef)(null);
    const datePickerRef = (0, react_1.useRef)(null);
    const [scheduledState, setScheduledState] = react_1.default.useState("yes");
    const showDatePicker = scheduledState === "no";
    const handleScheduledChange = (event, newScheduledState) => {
        setScheduledState(newScheduledState);
    };
    const handleFileInputChange = (newValue) => {
        setSelectedFiles(newValue);
    };
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        // https://stackoverflow.com/a/48291476/5031798
        const formData = new FormData();
        // TODO: do for all the other things we want to require
        const isScheduled = scheduledState === "no";
        if (isScheduled && !((_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.value)) {
            // TODO; specify a nicer error msg
            alert("pls specify date");
            return;
        }
        const foodEvent = {
            food_category: foodCategoryRef.current.value,
            food_type: foodTypeRef.current.value,
            location: locationRef.current.value,
            content: descriptionRef.current.value,
            scheduled: isScheduled,
            scheduledDate: (_b = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _b === void 0 ? void 0 : _b.value,
        };
        formData.append("food_event", JSON.stringify(foodEvent));
        for (const file of selectedFiles) {
            formData.append("photo", file);
        }
        console.log("form data is", formData);
        try {
            const result = yield (0, utilities_1.postMultiform)("/api/foodevents/new", formData);
            console.log(result);
            navigate("/food");
        }
        catch (e) {
            console.log(e);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Container, { component: "form", maxWidth: "sm", sx: {
                "& .MuiTextField-root": { width: "100%" },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "100%",
                paddingTop: "30px",
            }, noValidate: true, autoComplete: "off" },
            react_1.default.createElement("h2", null, "Submit a New Food Event"),
            react_1.default.createElement(material_1.Autocomplete, { sx: { width: "100%" }, 
                // TODO: fix weird styling issue - hard to debug since the items are gone (ask in OH how to debug in the first place)
                // TODO: don't hardcode
                options: [
                    { label: "Meal" },
                    { label: "Snack" },
                    { label: "Drink" },
                    { label: "Groceries" },
                ], renderInput: (params) => (react_1.default.createElement(material_1.TextField, Object.assign({ inputRef: foodCategoryRef }, params, { label: "Category" }))) }),
            react_1.default.createElement(material_1.TextField, { sx: { m: 1 }, required: true, label: "Food Type", helperText: "Cuisine or dish type (pizza, Flour sandwiches, etc.)", inputRef: foodTypeRef }),
            react_1.default.createElement(material_1.TextField, { sx: { m: 1 }, required: true, label: "Location", helperText: "Builing + room number or name", inputRef: locationRef }),
            react_1.default.createElement(material_1.TextField
            // sx={{ m: 1, width: '50ch' }}
            // TODO: both are called description: rename one at least in the front end
            , { 
                // sx={{ m: 1, width: '50ch' }}
                // TODO: both are called description: rename one at least in the front end
                sx: { m: 1 }, label: "Description", multiline: true, rows: 4, helperText: "Any other details about quantity, quality, age of food event, location, etc.", inputRef: descriptionRef }),
            react_1.default.createElement(mui_file_input_1.MuiFileInput, { multiple: true, value: selectedFiles, onChange: handleFileInputChange, InputProps: {
                    inputProps: {
                        accept: "image/*",
                    },
                    startAdornment: react_1.default.createElement(AttachFile_1.default, null),
                }, clearIconButtonProps: {
                    title: "Remove",
                    children: react_1.default.createElement(Close_1.default, { fontSize: "small" }),
                }, placeholder: "Insert photo(s)", getInputText: (fileList) => fileList.map((file) => file.name).join(", "), helperText: "Click above! For multiple photos, please select and upload all at once." }),
            blobUrls.map((url) => (react_1.default.createElement("img", { src: url, width: "100%" }))),
            react_1.default.createElement(FormControl_1.default, { required: true, sx: { m: 2, display: "flex", alignItems: "center" } },
                react_1.default.createElement(FormLabel_1.default, { component: "legend" }, "Is this food available right now?"),
                react_1.default.createElement(RadioGroup_1.default, { row: true, value: scheduledState, onChange: handleScheduledChange },
                    react_1.default.createElement(FormControlLabel_1.default, { value: "yes", control: react_1.default.createElement(Radio_1.default, null), label: "Yes, right meow", sx: { mr: 5 } }),
                    react_1.default.createElement(FormControlLabel_1.default, { value: "no", control: react_1.default.createElement(Radio_1.default, null), label: "No, schedule an event instead" }))),
            showDatePicker && (react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs },
                react_1.default.createElement(demo_1.DemoItem, { label: react_1.default.createElement(Label, { componentName: "Schedule date/time" }) },
                    react_1.default.createElement(DateTimePicker_1.DateTimePicker, { inputRef: datePickerRef, slotProps: {
                            textField: {
                                required: true,
                            },
                        } })),
                react_1.default.createElement("div", null, " \u00A0 "),
                " ")),
            react_1.default.createElement(material_1.Button, { sx: { mt: 0, mb: 7.5 }, variant: "contained", onClick: onSubmit }, "Submit Food"))));
};
exports.NewFoodPage = NewFoodPage;
exports.default = exports.NewFoodPage;
